import { atom } from "recoil"
export const listMatchingApplicationRequestIdState = atom({
  key: "atoms/matching/listMatchingApplicationRequestIdState",
  default: 0,
})
